import { createTheme } from '@material-ui/core/styles';

import styles from './../assets/styles/default.scss';
import {
  muiAppBarTheme,
  muiBackdropTheme,
  muiCardActionsTheme,
  muiCardContentTheme,
  muiCardHeaderTheme,
  muiCardTheme,
  muiDialogTheme,
  muiDialogTitleTheme,
  muiFormControlLabel,  
  muiInputTheme,
  muiMenuItemTheme,
  muiSelectTheme,
  muiSnackbar,
} from './themes';
import muiChipTheme from './themes/muiChipTheme';
import muiBadgeTheme from './themes/muiBadgeTheme';

export const SICREDI_GREEN_THEME = 'SICREDI_GREEN_THEME';
export const PUFV_BLUE_THEME = 'PUFV_BLUE_THEME';
export const PUFV_YELLOW_THEME = 'PUFV_YELLOW_THEME';
export const ERROR_THEME = 'ERROR_THEME';
export const WARNING_THEME = 'WARNING_THEME';
export const DISABLED_THEME = 'DISABLED_THEME';

export const THEME_COLORS = [
  SICREDI_GREEN_THEME,
  PUFV_BLUE_THEME,
  PUFV_YELLOW_THEME,
  ERROR_THEME,
  WARNING_THEME,
  DISABLED_THEME,
];

export const sicrediGreen = {
  main: styles.sicrediGreen,
  light: styles.sicrediGreenLight,
  dark: styles.sicrediGreenDark,
  contrastText: styles.sicrediGreenContrast,
};

export const transluscent = {
  main: '#ffffff00',
  light: '#ffffff33',
  dark: '#ffffff11',
  contrastText: '#ffffff',
};

export const pufvBlue = {
  main: styles.pufvBlue,
  light: styles.pufvBlueLight,
  dark: styles.pufvBlueDark,
  contrastText: styles.pufvBlueContrast,
};

export const pufvYellow = {
  main: styles.pufvYellow,
  light: styles.pufvYellowLight,
  dark: styles.pufvYellowDark,
  contrastText: styles.pufvYellowContrast,
};

export const error = {
  main: styles.error,
  light: styles.errorLight,
  dark: styles.errorDark,
  contrastText: styles.errorContrast,
};

export const warning = {
  main: styles.warning,
  light: styles.warningLight,
  dark: styles.warningDark,
  contrastText: styles.warningContrast,
};

export const disabled = {
  main: styles.disabled,
  light: styles.disabled,
  dark: styles.disabled,
  contrastText: '#FFFFFF',
};

export const getColorsByTheme = (theme) => {
  switch (theme) {
    case PUFV_BLUE_THEME:
      return pufvBlue;
    case PUFV_YELLOW_THEME:
      return pufvYellow;
    case ERROR_THEME:
      return error;
    case WARNING_THEME:
      return warning;
    case DISABLED_THEME:
      return disabled;
    case SICREDI_GREEN_THEME:
    default:
      return sicrediGreen;
  }
};

export const primaryFontFamily = styles.defaultFontFamily;

export const defaultTypography = {
  useNextVariants: true,
  body1: {
    fontFamily: primaryFontFamily,
  },
  body1Next: {
    fontFamily: primaryFontFamily,
  },
  body2: {
    fontFamily: primaryFontFamily,
  },
  body2Next: {
    fontFamily: primaryFontFamily,
  },
  button: {
    fontFamily: primaryFontFamily,
  },
  buttonNext: {
    fontFamily: primaryFontFamily,
  },
  caption: {
    fontFamily: primaryFontFamily,
  },
  captionNext: {
    fontFamily: primaryFontFamily,
  },
  display1: {
    fontFamily: primaryFontFamily,
  },
  display2: {
    fontFamily: primaryFontFamily,
  },
  display3: {
    fontFamily: primaryFontFamily,
  },
  display4: {
    fontFamily: primaryFontFamily,
  },
  fontFamily: primaryFontFamily,
  h1: {
    fontFamily: primaryFontFamily,
  },
  h2: {
    fontFamily: primaryFontFamily,
  },
  h3: {
    fontFamily: primaryFontFamily,
  },
  h4: {
    fontFamily: primaryFontFamily,
  },
  h5: {
    fontFamily: primaryFontFamily,
  },
  h6: {
    fontFamily: primaryFontFamily,
  },
};

export const fabThemes = {
  transluscent: createTheme({
    typography: defaultTypography,
    palette: {
      primary: transluscent,
    },
    shadows: ['none'],
    overrides: {
      MuiFab: {
        root: {
          width: 30,
          minWidth: 30,
          height: 30,
          minHeight: 30,
          boxShadow: 'none',
        },
        label: {
          textTransform: 'none',
        },
      },
    },
  }),
  default: createTheme({
    typography: defaultTypography,

    overrides: {
      MuiFab: {
        root: {
          width: 50,
          height: 50,
        },
        primary: {
          backgroundColor: sicrediGreen.main,
        },
        label: {
          textTransform: 'none',
        },
      },
    },

    palette: {
      primary: sicrediGreen,
      error: error,
    },
  }),
  pufvBlue: createTheme({
    typography: defaultTypography,

    overrides: {
      MuiFab: {
        root: {
          width: 50,
          height: 50,
        },
        label: {
          textTransform: 'none',
        },
      },
    },

    palette: {
      primary: pufvBlue,
      error: error,
    },
  }),
  pufvYellow: createTheme({
    typography: defaultTypography,

    overrides: {
      MuiFab: {
        root: {
          width: 50,
          height: 50,
        },
        label: {
          textTransform: 'none',
        },
      },
    },

    palette: {
      primary: pufvYellow,
      error: error,
    },
  }),
  error: createTheme({
    typography: defaultTypography,

    overrides: {
      MuiFab: {
        root: {
          width: 50,
          height: 50,
        },
        label: {
          textTransform: 'none',
        },
      },
    },

    palette: {
      primary: error,
      error: error,
    },
  }),
  warning: createTheme({
    typography: defaultTypography,

    overrides: {
      MuiFab: {
        root: {
          width: 50,
          height: 50,
        },
        label: {
          textTransform: 'none',
        },
      },
    },

    palette: {
      primary: warning,
      error: error,
    },
  }),
};

export const getFabTheme = (themeName) => {
  const theme = themeName || 'default';
  if (theme && fabThemes[theme]) {
    return fabThemes[theme];
  }
  return fabThemes.default;
};

export const buttonThemes = {
  default: createTheme({
    typography: defaultTypography,

    overrides: {
      MuiButton: {
        label: {
          textTransform: 'none',
        },
      },
    },

    palette: {
      primary: sicrediGreen,
      error: error,
    },
  }),
  pufvBlue: createTheme({
    typography: defaultTypography,

    overrides: {
      MuiButton: {
        label: {
          textTransform: 'none',
        },
      },
    },

    palette: {
      primary: pufvBlue,
      error: error,
    },
  }),
  pufvYellow: createTheme({
    typography: defaultTypography,

    overrides: {
      MuiButton: {
        label: {
          textTransform: 'none',
        },
      },
    },

    palette: {
      primary: pufvYellow,
      error: error,
    },
  }),
  error: createTheme({
    typography: defaultTypography,

    overrides: {
      MuiButton: {
        label: {
          textTransform: 'none',
        },
      },
    },

    palette: {
      primary: error,
      error: error,
    },
  }),
  warning: createTheme({
    typography: defaultTypography,

    overrides: {
      MuiButton: {
        label: {
          textTransform: 'none',
        },
      },
    },

    palette: {
      primary: warning,
      error: error,
    },
  }),
};

export const getButtonTheme = (themeName) => {
  const theme = themeName || 'default';
  if (theme && buttonThemes[theme]) {
    return buttonThemes[theme];
  }
  return buttonThemes.default;
};

export const getSearchTextFieldTheme = () => {
  return createTheme({
    typography: defaultTypography,

    overrides: {
      MuiInputBase: {
        input: {
          padding: 0,
        },
      },
      MuiInput: {
        root: {
          lineHeight: '40px',
        },
        underline: {
          '&:before': {
            borderBottom: 'none',
          },
          '&:hover:before': {
            borderBottom: 'none',
            opacity: 0,
          },
          '&:after': {
            content: 'none',
          },
          '&$error:before': {
            borderBottom: 'none',
          },
          '&$error:hover:before': {
            borderBottom: 'none',
            opacity: 0.5,
          },
          '&$disabled:before, &$disabled:hover:before ': {
            borderBottom: `none`,
          },
        },
      },
    },
  });
};

export const getCustomMaterialTheme = () => {
  let theme = createTheme({
    typography: defaultTypography,

    palette: {
      primary: sicrediGreen,
      secondary: pufvBlue,
      sicrediGreen: sicrediGreen,
      pufvBlue: pufvBlue,
      error: error,
    },
  });

  muiBadgeTheme(theme);

  muiAppBarTheme(theme);

  muiBackdropTheme(theme);

  muiCardActionsTheme(theme);

  muiCardContentTheme(theme);

  muiCardHeaderTheme(theme);

  muiCardTheme(theme);

  muiChipTheme(theme, pufvBlue);

  muiDialogTheme(theme);

  muiDialogTitleTheme(theme);

  muiFormControlLabel(theme);

  muiInputTheme(theme);

  muiMenuItemTheme(theme);

  muiSelectTheme(theme);

  muiSnackbar(theme);

  return theme;
};
